import { makeStyles } from '@mui/styles'
import {
  AQUA_GREEN,
  ERROR,
  NEON_BLUE_LIGHT,
  SHAMROCK,
  SLATE_GREY,
  SOLITUDE,
} from '@returnmates/client-core/src/constants/colors'
import { SnackBarStatuses } from '@returnmates/client-core/src/type'

import { POPPINS } from '../../constants/styles/fonts'

interface Props {
  isOperationPage?: boolean
  isAuditPage?: boolean
  type?: SnackBarStatuses
}

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: 55,
    height: '100%',
    borderRight: `1px solid ${SOLITUDE}`,
    zIndex: 113,
    background: `linear-gradient(to bottom, ${AQUA_GREEN} 0%, ${AQUA_GREEN} 50%, ${NEON_BLUE_LIGHT} 100%)`,
  },
  main: {
    height: '100%',
  },
  logoWrapper: {
    marginTop: 15,
  },
  linksList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '95%',
    paddingTop: '10px',

    '& > div': {
      width: '100%',
    },
  },
  link: {
    width: '100%',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:not(:last-child)': {
      marginBottom: 10,
    },
  },
  active: {
    borderLeft: `6px solid transparent`,
    borderRight: `6px solid ${NEON_BLUE_LIGHT}`,
  },
  linkIcon: {
    minWidth: 29,
    minHeight: 29,
  },
  logoutLink: {
    marginTop: 'auto',
    marginBottom: 30,
  },
  notificationBlock: {
    width: '100%',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  notificationIcon: {
    color: SLATE_GREY,
    cursor: 'pointer',
  },
  popperBlock: {
    position: 'absolute',
    width: 500,
    height: 800,
  },
  poppover: {
    zIndex: 114,
    left: '10px !important',
    width: 600,
    backgroundColor: '#FFFFFF',
  },
  listWrap: {
    border: `1px solid ${SOLITUDE}`,
    borderRadius: '5px',
  },
  notificationList: {
    maxHeight: 800,
    overflow: 'auto',
  },
  listItem: {
    '&:not(:last-child)': {
      borderBottom: `1px solid ${SOLITUDE}`,
    },
  },
  listItemText: {
    '& > span': {
      fontFamily: POPPINS,
      fontSize: 16,
      color: ({ type }: Props) => (type === SnackBarStatuses.SUCCESS ? SHAMROCK : ERROR),
    },
  },
  emptyState: {
    fontFamily: POPPINS,
    fontSize: 16,
    color: SLATE_GREY,
    padding: '30px 20px',
  },
  dashoardIcon: {
    '& > svg': {
      marginLeft: 3,
    },
  },
}))

export default useStyles
